export default __webpack_public_path__ + "static/media/favicon.f2619bb7.svg";